var React = require('react');

function RadioOption (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"6","cy":"6","r":"5.5","fill":"transparent","key":0}),React.createElement("circle",{"cx":"6","cy":"6","r":"3.5","stroke":"transparent","key":1})]);
}

RadioOption.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 12 12"};

module.exports = RadioOption;

RadioOption.default = RadioOption;
